<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-report-source-dialog-form">
    <mat-form-field>
      <mat-label>Name (required)</mat-label>
      <input matInput
             name="reportEmbeddedTypeName"
             [(ngModel)]="data.reportEmbeddedType.name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Report Source</mat-label>
      <mat-select name="data.reportSourceId" [(ngModel)]="data.reportEmbeddedType.reportSourceId">
        <mat-option *ngFor="let reportSource of data.reportSources" [value]="reportSource.reportSourceId">{{ reportSource.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Filter Page (required)</mat-label>
      <input matInput
             name="reportEmbeddedTypeFiltersPage"
             [(ngModel)]="data.reportEmbeddedType.filterPage" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Report Page</mat-label>
      <input matInput
             name="reportPage"
             [(ngModel)]="newReportPage" />
    </mat-form-field><br />
    <ng-container>
      <div width="20%">
        <button mat-raised-button color="primary" (click)="addReportPage()">Add Page</button>
      </div>
    </ng-container><br />
    <ng-container>
      <table>
        <thead>
          <tr>
            <th>Page</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reportPage of reportPages; index as i">
            <td>{{ reportPage }}</td>
            <td>&nbsp;&nbsp;<a href="#" (click)="removeReportPage(i)">Remove</a>&nbsp;&nbsp;</td>
            <td>&nbsp;&nbsp;<a *ngIf="i > 0" href="#" (click)="movePageUp(i)">Move Up</a>&nbsp;&nbsp;</td>
            <td>&nbsp;&nbsp;<a *ngIf="i < (reportPages.length - 1)" href="#" (click)="movePageDown(i)">Move Down</a>&nbsp;&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          color="primary"
          (click)="onConfirmClick()"
          cdkFocusInitial>
    Confirm
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
